import React from 'react';
import DropdownList from 'react-widgets/lib/DropdownList';
import { ValueInput } from './ValueInput';
import { fromJS, List, Map } from 'immutable';
import { Currency } from '@/consts/currency';
import { handleFormChanged } from '@/store/allaround.store.js';
import { connect } from 'react-redux';
import { getCurrencyStatesWrapper } from '../../../util/util';

class CurrencyInput extends React.Component {
  constructor(props) {
    super(props);
    this.setRate = this.setRate.bind(this);
    this.changeCurrency = this.changeCurrency.bind(this);
    this.setDefaultRates = this.setDefaultRates.bind(this);
    this.options = [];
    this.state = { data: this.options, ratesSet: false };
  }

  componentWillMount() {
    getCurrencyStatesWrapper();
    this.fillData(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.props.currencies !== props.currencies
      || (props.defaultValueRates && !this.state.ratesSet)) {
      this.fillData(props);
    }
  }

  setDefaultRates(props = this.props) {
    if (props.defaultValueRates) {
      const defaultValueRates = Array.isArray(props.defaultValueRates) ?
        fromJS(props.defaultValueRates) : props.defaultValueRates;
      defaultValueRates.forEach(rate => this.setRate(rate.get('value'), rate.get('rate'), true));
      this.setState({ ratesSet: true });
    }
    this.setState({ currency: props.defaultValue ? props.defaultValue : Currency.DOLLAR });
  }

  setRate(currency, rate, init = false) {
    const data = this.options.map(elem => {
      if (elem.value == currency) {
        const newElem = elem;
        if (!rate) {
          rate = this.props.usdRates.find(r =>                          //eslint-disable-line
            r.get('currency') == currency, this, new Map()).get('rate');
        }
        newElem.rate = rate;
        return newElem;
      }
      return elem;
    });
    this.setState({ data });
    if (!init) {
      this.props.handleFormChanged();
    }
    if (this.props.onChange && !init) {
      this.props.onChange({ currency: this.state.currency, rates: data });
    }
  }

  fillData = (props = this.props) => {
    this.options = props.currencies.filter(cs => cs.get('state') || cs.get('currency') === 'USD')
      .map(cs => ({ value: cs.get('currency'), label: cs.get('sign'),
        rate: undefined, setRate: this.setRate }))
      .toJS();
    this.setDefaultRates();
    this.setState({ data: this.options });
  };

  changeCurrency(e) {
    this.props.handleFormChanged();
    if (e) {
      this.setState({ currency: e.value });
      if (this.props.onChange) {
        if (this.props.noRates) {
          this.props.onChange(e.value);
        } else {
          this.props.onChange({ currency: e.value, rates: this.state.data });
        }
      }
    }
  }

  render() {
    const defaultValue = this.props.defaultValue ?
      this.state.data.find(elem => elem.value == this.props.defaultValue)
      : this.options.find(o => o.value === 'USD');
    const defaultCurrency = defaultValue ? defaultValue.value : Currency.DOLLAR;
    return (
      <div>
        <input
          style={{ display: 'none' }}
          name={this.props.name}
          value={this.state.currency ? this.state.currency : defaultCurrency}
          onChange={() => ({})}
        />
        {this.props.noRates ?
          <DropdownList
            className="currency-input currency-input-no-rates"
            style={this.props.style}
            disabled={this.props.disabled}
            data={this.state.data} valueField="value" textField="label"
            value={defaultValue}
            onChange={this.changeCurrency}
          />
          :
          <DropdownList
            style={this.props.style}
            disabled={this.props.disabled}
            className="currency-input"
            data={this.state.data} valueField="value" textField="label"
            value={defaultValue}
            itemComponent={ValueInput}
            onChange={this.changeCurrency}
          />}
      </div>
    );
  }
}

CurrencyInput.propTypes = {
  style: React.PropTypes.object,
  onChange: React.PropTypes.func,
  defaultValue: React.PropTypes.string,
  noRates: React.PropTypes.bool,
  name: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  handleFormChanged: React.PropTypes.func,
  usdRates: React.PropTypes.object,
  currencies: React.PropTypes.object,
};

export default connect((state) => ({
  usdRates: state.getIn(['data', 'currencies', 'USD', 'rates'], new List()),
  currencies: state.getIn(['data', 'currencies', 'states'], new List()),
}), (
    dispatch => ({
      handleFormChanged() {
        handleFormChanged(dispatch);
      },
    })
  ))(CurrencyInput);
